export default class SingleBack {
    
    
    static get selector() {
        return '.single__back';
    }

    constructor(el) {
        this.el = el;
        this.setEvents();
    }

    go_back(e) {
        history.go(-1); // Try to go back
    }

    setEvents() {
        this.el.addEventListener('click', this.e_click.bind(this));
    }

    e_click(e) {
        e.preventDefault();
        this.go_back(e);
    }

}